import * as z from "zod/v4";

export const disconnectOkendoIntegration = {
  name: "disconnectOkendoIntegration" as const,
  input: z.null(),
  output: z.null(),
};
